import { IUserModel } from '../models/user.model';
import { canManageUserCompetences } from './can-manage-user-competences';

export function getInactiveUserCompetenceTooltip(
  user: IUserModel | undefined,
  tenantId: string | undefined,
  userId: string | undefined
): string {
  if (!user || user.id !== userId) {
    return '';
  }

  return canManageUserCompetences(user, tenantId, userId)
    ? ''
    : 'userCompetencesCannotBeChangedForInactiveUser';
}
